/**
 * ROB-2 Scoring Helpers
 *
 * Shared helper functions, types, and interfaces used by the scoring engine.
 */
// Helper: check if answer matches any value in a set
export const inSet = (answer, ...values) => values.includes(answer);
// Helper: check if answer is Yes or Probably Yes
export const isYesPY = (answer) => inSet(answer, 'Y', 'PY');
// Helper: check if answer is No or Probably No
export const isNoPPN = (answer) => inSet(answer, 'N', 'PN');
// Helper: check if answer is No, Probably No, or No Information
export const isNoPPNNI = (answer) => inSet(answer, 'N', 'PN', 'NI');
//# sourceMappingURL=scoring-helpers.js.map